import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/marketing-campaigns/new/loading';

export const Route = createFileRoute('/_private/marketing-campaigns/new')({
  pendingComponent: Loading,
});
